import { Stack } from '@mui/material';

import clsx from 'clsx';

import RadioGroup from '../../../../components/HookFormControls/RadioGroup';
import { CourseListItem } from '../../../../db/courses/types';
import NoCourses from '../../../course/NoCourses';
import { FormValues } from '../types';
import Skeleton from './Skeleton';
import { CourseCard, courseListClasses, RadioOption } from './styles';
import useCourseList, { UseCourseList } from './vm';

export interface CourseListProps<T extends FormValues> extends UseCourseList<T> {
  isLoading: boolean;
  courses: CourseListItem[];
  className?: string;
}

const CourseList = <T extends FormValues>({ isLoading, courses, className, ...vmProps }: CourseListProps<T>) => {
  const { control, name } = vmProps;
  const { selectedCourseId } = useCourseList(vmProps);

  if (isLoading) {
    return <Skeleton />;
  }

  if (courses.length === 0) {
    return <NoCourses className={className} />;
  }

  return (
    <RadioGroup control={control} name={name} fullWidth className={className}>
      <Stack gap={1.5} px={2} py={0.5} my={-0.5} maxWidth="100%">
        {courses.map((course) => (
          <RadioOption key={course.courseId} value={course.courseId}>
            <CourseCard
              {...course}
              className={clsx(courseListClasses.courseCard, {
                [courseListClasses.selectedCourse]: course.courseId === selectedCourseId,
              })}
            />
          </RadioOption>
        ))}
      </Stack>
    </RadioGroup>
  );
};

export default CourseList;
